export const emLineSharedWithOthers = `<?xml version="1.0" encoding="UTF-8"?>
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:base="http://www.t-mobile.com/esi/base" xmlns:ema="http://services.tmobile.com/esi/email">
   <soapenv:Header />
   <soapenv:Body>
      <sendEmailRequest xmlns="http://services.tmobile.com/esi/email" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope" xmlns:wsa="http://schemas.xmlsoap.org/ws/2004/08/addressing" xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd" xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
         <requestHeader xmlns="http://www.t-mobile.com/esi/base">
            <applicationId>WSG</applicationId>
            <channelId>WSG</channelId>
            <operatorId>1234</operatorId>
         </requestHeader>
         <senderInfo>
            <fromName>T-Mobile Permissions</fromName>
            <emailId>permissions@permissions.t-mobile.com</emailId>
         </senderInfo>
         <email>
            <msisdn>$msisdn_value</msisdn>
            <profile>Australis</profile>
            <contentInfo>
               <templateId>EMLineSharedOthers</templateId>
               <dynamicData>
                  <nameValuePair>
                     <name>TMOID1</name>
                     <value>$tmoid_emailId</value>
                  </nameValuePair>
                  <nameValuePair>
                     <name>TMOIDOWNER</name>
                     <value>$tmoid_emailId_owner</value>
                  </nameValuePair>
                  <nameValuePair>
                     <name>MSISDN</name>
                     <value>$msisdn_value</value>
                  </nameValuePair>
                  <nameValuePair>
                     <name>FirstName</name>
                     <value>$first_Name</value>
                  </nameValuePair>
                  <nameValuePair>
                     <name>OwnerName</name>
                     <value>$owner_Name</value>
                  </nameValuePair>
               </dynamicData>
            </contentInfo>
            <receiverInfo>
               <fullName />
               <emailId>$receiver_emailId</emailId>
            </receiverInfo>
         </email>
      </sendEmailRequest>
   </soapenv:Body>
</soapenv:Envelope>`;

export const emLineSharedOwner = `<?xml version="1.0" encoding="UTF-8"?>
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:base="http://www.t-mobile.com/esi/base" xmlns:ema="http://services.tmobile.com/esi/email">
   <soapenv:Header />
   <soapenv:Body>
      <sendEmailRequest xmlns="http://services.tmobile.com/esi/email" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope" xmlns:wsa="http://schemas.xmlsoap.org/ws/2004/08/addressing" xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd" xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
         <requestHeader xmlns="http://www.t-mobile.com/esi/base">
            <applicationId>WSG</applicationId>
            <channelId>WSG</channelId>
            <operatorId>1234</operatorId>
         </requestHeader>
         <senderInfo>
            <fromName>T-Mobile Permissions</fromName>
            <emailId>permissions@permissions.t-mobile.com</emailId>
         </senderInfo>
         <email>
            <msisdn>$msisdn_value</msisdn>
            <profile>Australis</profile>
            <contentInfo>
               <templateId>EMLineOwnerShared</templateId>
               <dynamicData>
                  <nameValuePair>
                     <name>TMOID1</name>
                     <value>$tmoid_emailId</value>
                  </nameValuePair>
                  <nameValuePair>
                     <name>MSISDN</name>
                     <value>$msisdn_value</value>
                  </nameValuePair>
                  <nameValuePair>
                     <name>FirstName</name>
                     <value>$first_Name</value>
                  </nameValuePair>
               </dynamicData>
            </contentInfo>
            <receiverInfo>
               <fullName />
               <emailId>$receiver_emailId</emailId>
            </receiverInfo>
         </email>
      </sendEmailRequest>
   </soapenv:Body>
</soapenv:Envelope>`;

export const emLineUserWithTMOID = `<?xml version="1.0" encoding="utf-8"?>
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ema="http://services.tmobile.com/esi/email" xmlns:base="http://www.t-mobile.com/esi/base">
  <soapenv:Header/>
  <soapenv:Body>
    <sendEmailRequest xmlns="http://services.tmobile.com/esi/email" xmlns:wsa="http://schemas.xmlsoap.org/ws/2004/08/addressing" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd" xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd">
      <requestHeader xmlns="http://www.t-mobile.com/esi/base">
        <applicationId>WSG</applicationId>
        <channelId>WSG</channelId>
        <operatorId>1234</operatorId>
      </requestHeader>
      <senderInfo>
        <fromName>T-Mobile Permissions</fromName>
        <emailId>permissions@permissions.t-mobile.com</emailId>
      </senderInfo>
      <email>
        <msisdn>$msisdn_value</msisdn>
        <profile>Australis</profile>
        <contentInfo>
          <templateId>EMLineUserWithTMOID</templateId>
          <dynamicData>
            <nameValuePair>
              <name>TMOID1</name>
              <value>$tmoid_emailId_owner</value>
            </nameValuePair>
            <nameValuePair>
              <name>MSISDN</name>
              <value>$msisdn_value</value>
            </nameValuePair>
          </dynamicData>
        </contentInfo>
        <receiverInfo>
          <fullName>
          </fullName>
          <emailId>$receiver_emailId</emailId>
        </receiverInfo>
      </email>
    </sendEmailRequest>
    </soapenv:Body>
    </soapenv:Envelope>`;

export const emLineWithOutTMOID = `<?xml version="1.0" encoding="utf-8"?>
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ema="http://services.tmobile.com/esi/email" xmlns:base="http://www.t-mobile.com/esi/base">
  <soapenv:Header/>
  <soapenv:Body>
    <sendEmailRequest xmlns="http://services.tmobile.com/esi/email" xmlns:wsa="http://schemas.xmlsoap.org/ws/2004/08/addressing" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd" xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd">
      <requestHeader xmlns="http://www.t-mobile.com/esi/base">
        <applicationId>WSG</applicationId>
        <channelId>WSG</channelId>
        <operatorId>1234</operatorId>
      </requestHeader>
      <senderInfo>
        <fromName>T-MobilePermissions</fromName>
        <emailId>permissions@permissions.t-mobile.com</emailId>
      </senderInfo>
      <email>
        <msisdn>$msisdn_value</msisdn>
        <profile>Australis</profile>
        <subject>Register for T-Mobile DIGITS Access</subject>
        <contentInfo>
          <templateId>EMLineUserWithOutTMOID</templateId>
          <dynamicData>
            <nameValuePair>
              <name>MSISDN</name>
              <value>$msisdn_value</value>
            </nameValuePair>
            <nameValuePair>
              <name>TMOID</name>
              <value>$tmoid_emailId_owner</value>
            </nameValuePair>
            <nameValuePair>
              <name>redirecturl</name>
              <value>$redirect_url</value>
            </nameValuePair>
          </dynamicData>
        </contentInfo>
        <receiverInfo>
          <fullName/>
          <emailId>$receiver_emailId</emailId>
        </receiverInfo>
      </email>
    </sendEmailRequest>
    </soapenv:Body>
    </soapenv:Envelope>`;

export const emLineUserRevoked = `<?xml version="1.0" encoding="utf-8"?>
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ema="http://services.tmobile.com/esi/email" xmlns:base="http://www.t-mobile.com/esi/base">
  <soapenv:Header/>
  <soapenv:Body>
    <sendEmailRequest xmlns="http://services.tmobile.com/esi/email" xmlns:wsa="http://schemas.xmlsoap.org/ws/2004/08/addressing" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd" xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd">
      <requestHeader xmlns="http://www.t-mobile.com/esi/base">
        <applicationId>WSG</applicationId>
        <channelId>WSG</channelId>
        <operatorId>1234</operatorId>
      </requestHeader>
      <senderInfo>
        <fromName>T-Mobile Permissions</fromName>
        <emailId>permissions@permissions.t-mobile.com</emailId>
      </senderInfo>
      <email>
        <msisdn>$msisdn_value</msisdn>
        <profile>Australis</profile>
        <contentInfo>
          <templateId>EMRevokedUser</templateId>
          <dynamicData>
            <nameValuePair>
              <name>TMOID1</name>
              <value>$tmoid_emailId</value>
            </nameValuePair>
            <nameValuePair>
              <name>MSISDN</name>
              <value>$msisdn_value</value>
            </nameValuePair>
          </dynamicData>
        </contentInfo>
        <receiverInfo>
          <fullName>
          </fullName>
          <emailId>$receiver_emailId</emailId>
        </receiverInfo>
      </email>
    </sendEmailRequest>
    </soapenv:Body>
    </soapenv:Envelope>
`;

export const emLineOthersRevoked = `<?xml version="1.0" encoding="UTF-8"?>
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:base="http://www.t-mobile.com/esi/base" xmlns:ema="http://services.tmobile.com/esi/email">
   <soapenv:Header />
   <soapenv:Body>
      <sendEmailRequest xmlns="http://services.tmobile.com/esi/email" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope" xmlns:wsa="http://schemas.xmlsoap.org/ws/2004/08/addressing" xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd" xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
         <requestHeader xmlns="http://www.t-mobile.com/esi/base">
            <applicationId>WSG</applicationId>
            <channelId>WSG</channelId>
            <operatorId>1234</operatorId>
         </requestHeader>
         <senderInfo>
            <fromName>T-Mobile Permissions</fromName>
            <emailId>permissions@permissions.t-mobile.com</emailId>
         </senderInfo>
         <email>
            <msisdn>$msisdn_value</msisdn>
            <profile>Australis</profile>
            <contentInfo>
               <templateId>EMLineRevokedOthers</templateId>
               <dynamicData>
                  <nameValuePair>
                     <name>TMOID1</name>
                     <value>$tmoid_emailId</value>
                  </nameValuePair>
                  <nameValuePair>
                     <name>TMOIDOWNER</name>
                     <value>$tmoid_emailId_owner</value>
                  </nameValuePair>
                  <nameValuePair>
                     <name>MSISDN</name>
                     <value>$msisdn_value</value>
                  </nameValuePair>
                  <nameValuePair>
                     <name>FirstName</name>
                     <value>$first_Name</value>
                  </nameValuePair>
                  <nameValuePair>
                     <name>OwnerName</name>
                     <value>$owner_Name</value>
                  </nameValuePair>
               </dynamicData>
            </contentInfo>
            <receiverInfo>
               <fullName />
               <emailId>$receiver_emailId</emailId>
            </receiverInfo>
         </email>
      </sendEmailRequest>
   </soapenv:Body>
</soapenv:Envelope>
`;

export const emLineOwnerRevoked = `<?xml version="1.0" encoding="utf-8"?>
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ema="http://services.tmobile.com/esi/email" xmlns:base="http://www.t-mobile.com/esi/base">
  <soapenv:Header/>
  <soapenv:Body>
    <sendEmailRequest xmlns="http://services.tmobile.com/esi/email" xmlns:wsa="http://schemas.xmlsoap.org/ws/2004/08/addressing" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd" xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd">
      <requestHeader xmlns="http://www.t-mobile.com/esi/base">
        <applicationId>WSG</applicationId>
        <channelId>WSG</channelId>
        <operatorId>1234</operatorId>
      </requestHeader>
      <senderInfo>
        <fromName>T-Mobile Permissions</fromName>
        <emailId>permissions@permissions.t-mobile.com</emailId>
      </senderInfo>
      <email>
        <msisdn>$msisdn_value</msisdn>
        <profile>Australis</profile>
        <contentInfo>
          <templateId>EMLineOwnerRevoked</templateId>
          <dynamicData>
            <nameValuePair>
              <name>TMOID1</name>
              <value>$tmoid_emailId</value>
            </nameValuePair>
            <nameValuePair>
              <name>MSISDN</name>
              <value>$msisdn_value</value>
            </nameValuePair>
            <nameValuePair>
              <name>FirstName</name>
              <value>$first_Name</value>
            </nameValuePair>
          </dynamicData>
        </contentInfo>
        <receiverInfo>
          <fullName>
          </fullName>
          <emailId>$receiver_emailId</emailId>
        </receiverInfo>
      </email>
    </sendEmailRequest>
    </soapenv:Body>
    </soapenv:Envelope>`;
